import React from 'react';
import { Slider } from '@mui/material';

const DSSlider = (props: React.ComponentProps<typeof Slider>) => {
  return <Slider color="primary" {...props} />;
};

export default DSSlider;
